import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DamageCodeService } from '../../../services/damage-code.service';
import { ReplaySubject, firstValueFrom } from 'rxjs';

import { RouterModule } from '@angular/router';
import { DamageCodeFilterForm } from '../../../form-model/damage-code-filter.form.model';
import '@maersk-global/mds-components-core/mc-multi-select';
import '@maersk-global/mds-components-core/mc-input-date';
import { AuthPolicies } from '../../../auth/auth-policies';
import { DamageCodeHeader } from '../../../models/damage-code-header.model';
import { CodeDescription } from '../../../models/code-description.model';

@Component({
  selector: 'app-damage-code-advance-filter',
  imports: [FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './damage-code-advance-filter.component.html',
  styleUrl: './damage-code-advance-filter.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DamageCodeAdvanceFilterComponent implements OnInit {
  @Input({ required: true }) damageCodeFilterForm!: FormGroup<DamageCodeFilterForm>;
  //@Input() damageCodeDescriptionList: boolean = true;
  @Input() bindMultiSelects: boolean = false;
  damageCodeData: DamageCodeHeader[] = [];
  damageCodeDescriptionList: (CodeDescription & { id?: string })[] = [];
  damageTypesList: CodeDescription[] = [
    { code: 'structural', description: '0 - Structural' },
    { code: 'reefer_unit', description: '1 - ReeferUnit' },
    { code: 'genset', description: '2 - Genset' },
  ];

  private readonly destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  constructor(
    private readonly damageCodeService: DamageCodeService,
    private readonly formBuilder: FormBuilder,
    public readonly authPolicy: AuthPolicies,
  ) {}

  ngOnInit() {
    this.addControlsToTheFormGroup();
    this.loadAllDamageCodeUniqueOptions();
  }

  private addControlsToTheFormGroup() {
    this.damageCodeFilterForm.addControl('damageCodeDescriptionList', this.formBuilder.control<string[]>([]));
    this.damageCodeFilterForm.addControl('damageTypesList', this.formBuilder.control<string[]>([]));
    this.damageCodeFilterForm.addControl('applyDCFilter', this.formBuilder.control<boolean | null>(null));
  }

  isControlInErrorState(control: FormControl): boolean | null {
    if (control.invalid && control.touched) {
      return true;
    }
    return null;
  }

  isLoadingOptions: boolean = false;
  async loadAllDamageCodeUniqueOptions() {
    this.isLoadingOptions = true;
    try {
      const damageCode = await firstValueFrom(this.damageCodeService.getUniqueDamageCodes());
      // assign a unique id per option to distinguish duplicate codes with different descriptions
      this.damageCodeDescriptionList = (damageCode || []).map((d, i) => ({ ...d, id: `${d.code}__${i}` }));
    } catch (error) {
      console.error('Error loading unique options:', error);
      this.damageCodeDescriptionList = [];
    } finally {
      this.isLoadingOptions = false;
    }
  }

  applyFilters() {
    // mark that filters should be applied so parent/list component reacts
    this.damageCodeFilterForm.controls.applyDCFilter.setValue(true);
  }

  clearFilters() {
    this.damageCodeFilterForm.reset({
      damageCodeDescriptionList: [],
      damageTypesList: [],
    });
    // Signal the parent/list to apply (empty) filters
    this.damageCodeFilterForm.controls.applyDCFilter.setValue(true);
  }
}
